import { BaseWebComponentDataProvider } from '../framework/BaseWebComponentDataProvider';
import {
  GetRowsRequest,
  GetSummaryRequest,
  GetSummaryResponse,
  SetFiltersRequest,
  UpdateSettingsRequest,
  UpdateSettingsResponse,
} from './types/common';

export class GridBaseDataProvider<
  Column extends number,
  ColumnKeys extends string
> extends BaseWebComponentDataProvider {
  private errorMessage = 'Not implemented';
  public companyFilterDataProvider: string | undefined;

  async getSummary(request: GetSummaryRequest<ColumnKeys>): Promise<GetSummaryResponse> {
    throw new Error(this.errorMessage);
  }

  async getRows(request: GetRowsRequest<Column, ColumnKeys>): Promise<any> {
    throw new Error(this.errorMessage);
  }

  async updateSettings(params: UpdateSettingsRequest<Column>): Promise<UpdateSettingsResponse> {
    throw new Error(this.errorMessage);
  }

  async setFilters(request: SetFiltersRequest<ColumnKeys>): Promise<{} | undefined> {
    throw new Error(this.errorMessage);
  }

  shouldDataReloadOnResetView(): boolean {
    return false;
  }
}
